"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useReducedMotionStyles", {
    enumerable: true,
    get: function() {
        return useReducedMotionStyles;
    }
});
const _react = require("@griffel/react");
const useReducedMotionStyles = /*#__PURE__*/ (0, _react.__styles)({
    reduced: {
        Hwfdqs: "f1bggi9a"
    }
}, {
    m: [
        [
            "@media screen and (prefers-reduced-motion: reduce){.f1bggi9a{transition-duration:0.01ms!important;}}",
            {
                m: "screen and (prefers-reduced-motion: reduce)"
            }
        ]
    ]
}); //# sourceMappingURL=useReducedMotionStyles.styles.js.map
